// DEPENDENCIES
import React, { useState, useEffect, useRef } from 'react';
// COMPONENTS
import { Switch, Route } from 'react-router-dom';
// CUSTOM COMPONENTS
import { PrivateRoute } from '../src/components/PrivateRoute';
import { PublicHeaderRoute } from '../src/components/PublicHeaderRoute';
// AUTHENTICATION PAGES
import LoginPage from '../src/pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
// MAIN PAGES
import DashboardPage from '../src/pages/DashboardPage';
import QuotePage from './pages/QuotePage';
// USER MANAGEMENT
import CreateNewClientPage from './pages/user-management/CreateNewClientPage';
import UserManagePage from './pages/user-management/UserManagePage';
// PRODUCT MANAGEMENT PAGES
import CreateNewMediaTypePage from './pages/product-management/CreateNewMediaTypePage';
import CreateNewCategoryPage from './pages/product-management/CreateNewCategoryPage';
import CreateNewProductPage from './pages/product-management/CreateNewProductPage';
// SALES MANAGEMENT PAGES
import CreateNewSalesToolPage from './pages/sales-management/CreateNewSalesToolPage';
import SalesToolDetailsPage from './pages/sales-management/SalesToolDetailsPage';
import QuoteSelectedCategoryPage from './pages/sales-management/QuoteSelectedCategoryPage';
// LISTING PAGES
import QuoteListingPage from './pages/listing-management/QuoteListingPage';
import MediaTypeListingPage from './pages/listing-management/MediaTypeListingPage';
import CategoryListingPage from './pages/listing-management/CategoryListingPage';
import ProductListingPage from './pages/listing-management/ProductListingPage';
import SalesToolListingPage from './pages/listing-management/SalesToolListingPage';
import CompanyListingPage from './pages/user-management/CompanyListingPage';
import UserListingPage from './pages/user-management/UserListingPage';
import ClientListManagePage from './pages/user-management/ClientListManagePage';
// SAMPLE/REFERENCE PAGES
import FormExamplePage from './pages/samples/FormSamplePage';
// QUOTE MANAGEMENT PAGES
import QuoteManagePage from './pages/sales-management/QuoteManagePage';
import CampaignSummaryPage from './pages/sales-management/CampaignSummaryPage';

export function Routes(props) {

    const [isLoggedIn, setIsLoggedIn] = useState(true);

    return (
        <>
            <Switch>
                <Route
                    exact
                    path="/"
                    component={LoginPage}
                />

                <Route
                    path="/forgot-password"
                    component={ForgotPasswordPage}
                />

                <PrivateRoute
                    path="/dashboard"
                    component={DashboardPage}
                    title="Dashboard"
                />

                <PrivateRoute
                    path="/new-campaign"
                    component={QuoteSelectedCategoryPage}
                    title="New Campaign Category Selection"
                />

                <PrivateRoute
                    path="/add-new-company"
                    component={CreateNewClientPage}
                    title="Add New Company"
                />

                <PrivateRoute
                    path="/company"
                    component={CreateNewClientPage}
                    title="Company Details"
                />

                <PrivateRoute
                    path="/add-new-media-type"
                    component={CreateNewMediaTypePage}
                    title="Add New Media Type"
                />

                <PrivateRoute
                    path="/media-type"
                    component={CreateNewMediaTypePage}
                    title="Media Type Details"
                />

                <PrivateRoute
                    path="/add-new-category"
                    component={CreateNewCategoryPage}
                    title="Add New Category"
                />

                <PrivateRoute
                    path="/category"
                    component={CreateNewCategoryPage}
                    title="Category Details"
                />

                <PrivateRoute
                    path="/add-new-product"
                    component={CreateNewProductPage}
                    title="Add New Product"
                />

                <PrivateRoute
                    path="/product"
                    component={CreateNewProductPage}
                    title="Product Details"
                />

                <PrivateRoute
                    path="/add-new-sales-tool"
                    component={CreateNewSalesToolPage}
                    title="Add New Sales Tool"
                />

                <PrivateRoute
                    path="/sales-tool"
                    component={CreateNewSalesToolPage}
                    title="Sales Tool Details"
                />

                <PrivateRoute
                    path="/sales-tool-details"
                    component={SalesToolDetailsPage}
                    title="Sales Tool Details"
                />

                <PrivateRoute
                    path="/campaigns"
                    component={QuoteListingPage}
                    title="Campaigns"
                />

                <PrivateRoute
                    path="/campaign"
                    component={QuoteManagePage}
                    title="Campaign"
                />

                <PrivateRoute
                    path="/media-types"
                    component={MediaTypeListingPage}
                    title="Media Types"
                />

                <PrivateRoute
                    path="/categories"
                    component={CategoryListingPage}
                    title="Categories"
                />

                <PrivateRoute
                    path="/products"
                    component={ProductListingPage}
                    title="Products"
                />

                <PrivateRoute
                    path="/sales-tools"
                    component={SalesToolListingPage}
                    title="Sales Tools"
                />

                <PrivateRoute
                    path="/companies"
                    component={CompanyListingPage}
                    title="Companies"
                />

                <PrivateRoute
                    path="/users"
                    component={UserListingPage}
                    title="Users"
                />

                <PrivateRoute
                    path="/user"
                    component={UserManagePage}
                    title="User Details"
                />

                <PrivateRoute
                    path="/add-new-user"
                    component={UserManagePage}
                    title="Add New User"
                />

                <PrivateRoute
                    path="/form-sample"
                    component={FormExamplePage}
                    title="Form Sample"
                />

                <PrivateRoute
                    path="/client-list"
                    component={ClientListManagePage}
                    title="Top 20"
                />

                <Route
                    path="/campaign-summary"
                    component={CampaignSummaryPage}
                    title="Summary"
                />
            </Switch>
        </>
    );
}